import React, { useContext, useEffect, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'src/components/loader';
import MyDownloadsHead from './my-downloads-head';
import MyDownloadsGrid from './my-downloads-grid';
import { clearAll, deleteMyDownload, getAllMyDownloads, getMyDownloadFileUri, retry } from './my-downloads-api';
import { IMyDownloads, MyDownloadStatus } from './my-downloads-types';
import { UTENotifier } from '../notification/ute-notifier';
import { DisplayDownloadFile } from 'src/helper/display-download-file';
import { MY_DOWNLOADS_CONSTANTS } from 'src/helper/constants';
import { MyDownloadContext } from 'src/context/ute-mydownload-context/mydownload-provider';

const MyDownloads = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [myDownloadsData, setMyDownloadsData] = useState<IMyDownloads[]>([]);
	const { myDownloadStatus } = useContext(MyDownloadContext);
	useEffect(() => {
		fetchMyDownloads(true);
	}, []);

	useEffect(() => {
		if (myDownloadStatus.length > 0) {
			fetchMyDownloads(myDownloadsData.length === 0);
		}
	}, [myDownloadStatus]);

	const fetchMyDownloads = (noLoader: boolean) => {
		setIsLoading(noLoader);
		getAllMyDownloads(
			(data) => {
				setIsLoading(false);
				setMyDownloadsData(data);
			},
			() => {
				setIsLoading(false);
				UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_FETCH_ALL);
			},
		);
	};

	const downloadFile = (storageAccountId: number, fileName: string, filePath: string) => {
		let displayDownloadFile = new DisplayDownloadFile();
		getMyDownloadFileUri(
			storageAccountId,
			fileName,
			filePath,
			(uri) => {
				if (uri && uri.length > 0) {
					displayDownloadFile.directDownload(uri);
				} else {
					UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_DOWNLOAD_FILE);
				}
			},
			() => {
				UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_DOWNLOAD_FILE);
			},
		);
	};

	const onDeleteMyDownload = (myDownloadId: number) => {
		deleteMyDownload(
			myDownloadId,
			(result: boolean) => {
				if (result) {
					UTENotifier.Success(MY_DOWNLOADS_CONSTANTS.SUCCESS_DELETE_DOCUMENT);
					fetchMyDownloads(true);
				} else {
					UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_DELETE_DOCUMENT);
				}
			},
			() => {
				UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_DELETE_DOCUMENT);
			},
		);
	};

	const onRetry = (myDownloadId: number) => {
		retry(
			myDownloadId,
			() => {
				fetchMyDownloads(true);
			},
			() => {
				UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_DELETE_DOCUMENT);
			},
		);
	};

	const onClearAll = () => {
		clearAll(
			(result: boolean) => {
				if (result) {
					UTENotifier.Success(MY_DOWNLOADS_CONSTANTS.SUCCESS_CLEAR_ALL_DOCUMENT);
					fetchMyDownloads(true);
				} else {
					UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_CLEAR_ALL_DOCUMENT);
				}
			},
			() => {
				UTENotifier.Error(MY_DOWNLOADS_CONSTANTS.ERROR_CLEAR_ALL_DOCUMENT);
			},
		);
	};

	return (
		<section className='pageModuleContainer'>
			<LoadingOverlay
				active={isLoading}
				spinner={<Loader />}
				text=''>
				<MyDownloadsHead
					showClearAllBtn={myDownloadsData.length > 0}
					onClearAll={onClearAll}></MyDownloadsHead>
				<MyDownloadsGrid
					data={myDownloadsData}
					onDownloadFile={downloadFile}
					onDeleteMyDownload={onDeleteMyDownload}
					onRetry={onRetry}></MyDownloadsGrid>
			</LoadingOverlay>
		</section>
	);
};

export default MyDownloads;
